import { Food, getFoodReferenceWeight } from '@cf-shared/data-model/food';
import { nutrientsForWeightForDisplay } from '@cf-shared/data-model/ingredient';
import { UiDisplayNutrient } from 'models/display-nutrient';
import { FormatNutrients } from 'util/formatting';

/**
 * The calories and macros a photo scanner's result row shows: what the row's grams of the food
 * hold (#6806).
 *
 * The row's food header carries the food's STORED values, which are per 100 g for an ordinary
 * food and the whole recipe's totals for a recipe, so on their own they say nothing about the
 * amount on the plate. This uses the same scaling the saved ingredient gets, so the row shows
 * what the meal or recipe will show once the food is added. A nutrient nobody measured stays
 * "--" rather than becoming 0.
 *
 * Pass the full food, read with `getFoodByIdAsync`: that read repairs a recipe's missing total
 * weight, and a search header has no stored nutrients to scale.
 */
export function scannedRowDisplayNutrients(food: Food, grams: number): UiDisplayNutrient[] {
  return FormatNutrients(nutrientsForWeightForDisplay(food.nutrients, grams, getFoodReferenceWeight(food)));
}
